var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00747 18.3325H9.97957C9.97957 18.3325 9.97957 12.6188 9.97957 12.0956C9.97957 11.2858 10.4531 10.5511 11.1903 10.2167L11.7667 9.95518C12.5039 9.62068 12.9774 8.88593 12.9774 8.07632C12.9774 7.53871 12.9774 1.66602 12.9774 1.66602C12.9868 1.66602 10.0054 1.66602 10.0054 1.66602V8.07632C10.0054 8.88593 9.53191 9.62068 8.79457 9.95518L8.21827 10.2167C7.48098 10.5511 7.00747 11.2858 7.00747 12.0956V18.3325ZM17.5239 1.66612C18.0937 1.66612 18.5554 2.12798 18.5554 2.6977V7.90314C18.5554 8.71277 18.0821 9.44752 17.3447 9.78202L16.7684 10.0434C16.0312 10.3779 15.5576 11.1127 15.5576 11.9223V17.301C15.5576 17.8708 15.0957 18.3327 14.5259 18.3327H12.5854C12.5854 18.3327 12.5854 12.4601 12.5854 11.9223C12.5854 11.1127 13.0589 10.3779 13.7962 10.0434L14.3726 9.78202C15.1098 9.44752 15.5834 8.71277 15.5834 7.90314V1.66612C15.5834 1.66612 16.8771 1.66612 17.5239 1.66612ZM7.41533 1.66602H5.4748C4.90506 1.66602 4.44321 2.12787 4.44321 2.6976V8.07632C4.44321 8.88593 3.9697 9.62068 3.23243 9.95518L2.65609 10.2167C1.91881 10.5511 1.44531 11.2858 1.44531 12.0956V17.301C1.44531 17.8708 1.90716 18.3325 2.4769 18.3325H4.41741C4.41741 16.2535 4.41741 14.1745 4.41741 12.0956C4.41741 11.2858 4.89091 10.5511 5.6282 10.2167L6.20453 9.95518C6.9418 9.62068 7.41533 8.88593 7.41533 8.07632C7.41533 5.93955 7.41533 3.80278 7.41533 1.66602Z",
    fill: "url(#paint0_linear_11546_21412)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11546_21412",
    x1: 4.67392,
    y1: 2.29102,
    x2: 14.9923,
    y2: 17.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#FEE45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#AEFEC3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeima);
export default __webpack_public_path__ + "static/media/heima.f951cfeb2f2d46d722a5a172a4f04b5b.svg";
export { ForwardRef as ReactComponent };